/** Main project script */

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.bdc = {
    init: function () {
        this.megaMenuTrigger();
        this.subMenuToggler();
        this.makeContainersClickable();
        this.swipeboxInit();
        this.scrollDown();
        // this.fixBanner();

        $('iframe[src*="youtube.com"]').each(function() {
            var delim = '&';
            var sVideoURL = $(this).attr('src');
            if (sVideoURL.indexOf('?') === -1) {
                delim = '?';
            }
            if (sVideoURL.indexOf('rel=0') === -1) {
                $(this).attr('src', sVideoURL + delim + 'rel=0');
            }
        });
    },
    megaMenuTrigger: function() {
        $(".mega-menu-trigger").click(function(e) {
            e.preventDefault();

            $(".nav-main").toggleClass('mega-menu-open');
            $(".mega-menu").toggleClass('open');
            $(".main").toggleClass('d-none');
            $(".footer-main").toggleClass('d-none');
        });
    },
    subMenuToggler: function() {
        $(".sub-menu-toggler").click(function(e) {
            e.preventDefault();

            var targ = $(this).attr('data-target');

            if (targ.length > 0) {
                $(targ).toggleClass('open');
            }
        });
    },
    makeContainersClickable: function() {
        $(".clickable-container[data-link]").click(function() {
            var href = $(this).attr('data-link');
            var openInNewWindow = $(this).attr('data-new-window');

            if (href) {
                if (openInNewWindow) {
                    window.open(href);
                } else {
                    window.location = href;
                }
            }

            return false;
        });
    },
    swipeboxInit: function() {
        $('.swipebox').swipebox({
            loopAtEnd: true,
            hideBarsDelay : 0,
            afterOpen: function() {
                var $selectorClose = $("#swipebox-close");
                var clickAction = "touchend click";

                $selectorClose.unbind(clickAction);

                $selectorClose.bind(clickAction, function(event) {
                    event.preventDefault();
                    event.stopPropagation();

                    $.swipebox.close();
                });
            }
        });
    },
    scrollDown: function() {
        $(".scroll-down-trigger").click(function() {
            $('html,body').animate({
                scrollTop: $(window).height()
            }, 1000);
        });
    },
    fixBanner: function() {
        $(window).scroll(function() {
            if ($('.page-banner').length > 0) {
                $('.page-banner').css('background-position', 'center calc(50% + ' + $(window).scrollTop() + 'px)');
            }
        });
    }
};

$(document).ready(function () {
    so.bdc.init();
});
